import React, { memo } from 'react';

import Popup from '../helpers/Popup';
import FetchingError from '../helpers/FetchingError';
import Button from '../helpers/Button';
import Input from '../helpers/Input';

const SaveQueryPopup = ({ isPopupFetching, isPopupFetchingError, isDisabled, onClose, onChange, onAddSaveQuery }) => {
  const header = 'Save Query';
  const footer = (
    <>
      <Button className="btn-primary" disabled={isDisabled} loading={isPopupFetching} onClick={onAddSaveQuery}>
        Save
      </Button>
      <Button onClick={onClose}>Close</Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="saveQuery" loading={isPopupFetching}>
      <Input
        className="input-md"
        id="queryName"
        label="Query Name"
        name="queryName"
        onChange={onChange}
        placeholder=""
        autoFocus
        showLabel
      />
      <FetchingError error={isPopupFetchingError} />
    </Popup>
  );
};

export default memo(SaveQueryPopup);
